export const NAME = 'flick';
export const LOAD_ERROR_MESSAGE = 'Cannot access flight position data: Data not available';
